import { connect } from "react-redux";
import TableBodyComponent from "../../../Components/RecordingsManagement/TableComponent/TableBodyComponent";

const mapStateToProps = (state) => ({
    tenantId: state.reducer.ACTIVE_TENANT,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TableBodyComponent);
